import bell from "../../../../images/bell.svg";
import React, {useEffect} from "react";
import {useFlintNotificationContext} from "../notifications/FlintNotificationContext";
import UnreadCommentsComponent from "./UnreadCommentsComponent";
import {useAuthenticationContext} from "../../../../utils/auth/AuthenticationContext";


export function CommentNotificationIcon() {
    const {rightSidebar} = useFlintNotificationContext();
    const {comments, rootModel} = useAuthenticationContext();
    function handleCommentsPreviewClicked() {
        if (!rootModel?.CurrentUserProfile.ShowNewCommentsPopup)
            return;
        if (rightSidebar.get.visible) {
            rightSidebar.hide();
            return;
        }
        rightSidebar.show(<UnreadCommentsComponent/>);
    }

    useEffect(() => {
        if (comments.get.length == 0)
            rightSidebar.hide();
    }, [comments.get.length]);
    
    const {state} = useCommentNotificationIcon();
    return (
        <div className={"notification-container position-relative"}>
            <img src={bell} alt="notification bell" onClick={handleCommentsPreviewClicked} className={"cursor-pointer"}/>
            {state.unreadComments.get.length > 0 &&
                <span
                    onClick={handleCommentsPreviewClicked}
                    className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger cursor-pointer">
                {state.unreadComments.get.length}
                    <span className="visually-hidden">unread messages</span>
            </span>}
        </div>
    )
}

function useCommentNotificationIcon() {
    const {comments} = useAuthenticationContext();
    return {
        state: {
            unreadComments: {get: comments.get},
        }
    }
}